<template>
    <div class="notice-detail-page">
        <div class="page-header">
            <div class="header-info">
                <span class="info-item">
                    <span class="label">招标项目名称：</span>
                    <span class="value">{{ projectName }}</span>
                </span>
                <span class="divider"></span>
                <span class="info-item">
                    <span class="label">招标项目编号：</span>
                    <span class="value">{{ projectCode }}</span>
                </span>
            </div>
        </div>

        <div class="form-container">
            <div class="section-header">
                <span class="title">中标公告信息</span>
            </div>

            <el-form ref="formRef" :model="form" :rules="rules" label-width="150px" class="notice-form">
                <el-form-item label="原公告名称" v-if="mode === 'change'">
                    <el-input v-model="originalBulletinName" disabled />
                </el-form-item>

                <el-form-item label="公告标题" prop="winBulletinName">
                    <el-input v-model="form.winBulletinName" placeholder="请输入公告标题" />
                </el-form-item>

                <el-form-item label="关联标段" prop="sections">
                    <el-checkbox-group v-model="selectedSectionCodes">
                        <el-checkbox v-for="section in sectionList" :key="section.bidSectionCode" :label="section.bidSectionCode" :disabled="mode === 'change'">
                            {{ section.bidSectionName }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="发布时间" prop="publicTime">
                    <el-date-picker v-model="form.publicTime" type="datetime" placeholder="请选择发布时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
                </el-form-item>

                <el-form-item label="公告正文" prop="winBulletinContent">
                    <RichTextEditor v-model="form.winBulletinContent" :height="300" placeholder="请输入公告正文..." toolbar-type="default" />
                </el-form-item>

                <el-form-item label="附件上传">
                    <div class="upload-area">
                        <el-button @click="handleUploadAttach"><i class="el-icon-upload2"></i> 上传附件</el-button>
                        <span class="upload-tip">支持pdf、word、excel格式，单个文件不超过50MB</span>
                    </div>
                    <div v-if="attachFileList && attachFileList.length > 0" class="attach-file-list">
                        <div v-for="(file, fIndex) in attachFileList" :key="fIndex" class="attach-file-item">
                            <span class="attach-file-name">{{ file.name }}</span>
                            <el-progress v-if="file.uploading" :percentage="file.progress"></el-progress>
                            <span v-if="file.uploaded && !file.uploading" class="attach-file-status">已上传</span>
                            <span v-if="!file.uploading && !file.uploaded && file.error" class="attach-file-error">上传失败</span>
                            <i class="el-icon-close attach-file-remove" @click="removeAttachFile(fIndex)"></i>
                        </div>
                    </div>
                </el-form-item>
            </el-form>

            <div class="form-footer">
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="info" @click="handleSave(0)" :loading="saveLoading">暂存</el-button>
                <el-button type="primary" @click="handleSave(1)" :loading="submitLoading">提交</el-button>
            </div>
        </div>

        <input type="file" ref="attachFileInput" style="display: none" @change="handleAttachFileChange" accept=".pdf,.doc,.docx,.xls,.xlsx" />
    </div>
</template>

<script>
import { Api_GetWinBulletinSemiDetail, Api_SaveWinBulletinSemi } from '@/api/modules/semiProcess'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import RichTextEditor from '@/components/common/RichTextEditor.vue'
import { getFileList } from '@/api/modules/base'

export default {
    name: 'BidWinAnnouncementEdit',
    components: { RichTextEditor },

    data() {
        return {
            mode: this.$route.query.mode,
            winBulletinCode: this.$route.query.winBulletinCode || '',
            originalWinBulletinCode: this.$route.query.originalWinBulletinCode || '',
            originalBulletinName: '',
            projectName: '',
            projectCode: '',
            sectionList: [],
            selectedSectionCodes: [],
            attachFileList: [],
            fileGuid: new Date().getTime() + Math.random().toString().substr(2, 5),
            saveLoading: false,
            submitLoading: false,
            form: {
                typeCode: Number(this.$route.query.typeCode) || (this.$route.query.mode === 'change' ? 2 : 1),
                projectCode: this.$route.query.projectCode,
                winBulletinName: '',
                publicTime: '',
                winBulletinContent: '',
                sections: []
            },
            rules: {
                winBulletinName: [{ required: true, message: '请输入公告标题', trigger: 'blur' }],
                publicTime: [{ required: true, message: '请选择发布时间', trigger: 'change' }]
            }
        }
    },

    created() {
        this.projectName = this.$route.query.projectName || ''
        this.projectCode = this.$route.query.projectCode || ''
        this.getDetail()
    },

    methods: {
        getDetail() {
            let params = { projectCode: this.projectCode }
            if (this.mode === 'change') {
                params.originalWinBulletinCode = this.originalWinBulletinCode
            }
            if (this.mode !== 'add' && this.mode !== 'change') {
                params.winBulletinCode = this.$route.query.winBulletinCode
            }
            Api_GetWinBulletinSemiDetail(params).then(res => {
                if (res.code === 200 && res.data) {
                    const data = res.data
                    if (this.mode === 'change') {
                        this.originalBulletinName = data.winBulletinName || ''
                    } else {
                        this.form.winBulletinName = data.winBulletinName || ''
                        this.form.publicTime = data.publicTime || ''
                        this.form.winBulletinContent = data.winBulletinContent || ''
                        this.form.typeCode = data.typeCode
                        this.fileGuid = data.fileGuid || this.fileGuid
                        if (data.fileGuid) { this.getAttachFileList(data.fileGuid) }
                    }
                    this.sectionList = data.sections || []
                    if (this.mode !== 'add') {
                        this.selectedSectionCodes = (data.sections || []).map(item => item.bidSectionCode)
                    }
                }
            }).catch(() => { this.$message.error('获取详情失败') })
        },

        handleCancel() { this.$router.back() },

        getAttachFileList(fileGuid) {
            getFileList(fileGuid).then(res => {
                if (res.code === 200 && res.data) {
                    this.attachFileList = (res.data || []).map(file => ({
                        name: file.fileName, size: file.fileSize, uploading: false, uploaded: true,
                        progress: 100, fileGuid: fileGuid, uploadFileId: file.fileId, filePath: file.fileUrl, fileExtension: file.fileExtension
                    }))
                }
            }).catch(() => { this.attachFileList = [] })
        },

        handleSave(status) {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    if (status === 1) { this.submitLoading = true } else { this.saveLoading = true }
                    const selectedSections = this.sectionList
                        .filter(s => this.selectedSectionCodes.includes(s.bidSectionCode))
                        .map(s => ({ bidSectionCode: s.bidSectionCode, bidSectionName: s.bidSectionName }))

                    const submitData = { ...this.form, status: status, sections: selectedSections, fileGuid: this.fileGuid }
                    if (this.mode !== 'add' && this.mode !== 'change' && this.winBulletinCode) {
                        submitData.winBulletinCode = this.winBulletinCode
                    }
                    // 变更公告传2，正常公告传1
                    submitData.typeCode = this.mode === 'change' ? 2 : 1

                    Api_SaveWinBulletinSemi(submitData).then(res => {
                        this.saveLoading = false; this.submitLoading = false
                        if (res.code === 200) {
                            this.$message.success(status === 1 ? '提交成功' : '暂存成功')
                            this.$router.push({ name: 'bidWinAnnouncement', query: { projectCode: this.projectCode, projectName: this.projectName } })
                        } else { this.$message.error(res.msg || '保存失败') }
                    }).catch(() => { this.saveLoading = false; this.submitLoading = false })
                }
            })
        },

        handleUploadAttach() {
            if (this.attachFileList.length >= 5) { this.$message.warning('最多只能上传5个附件'); return }
            this.$refs.attachFileInput.click()
        },

        async handleAttachFileChange(event) {
            const files = Array.from(event.target.files)
            if (files.length === 0) return
            const file = files[0]
            if (!this.checkFileType(file.name)) { this.$message.error(`文件 ${file.name} 格式不正确！`); event.target.value = ''; return }
            if (file.size / 1024 / 1024 > 50) { this.$message.error(`文件 ${file.name} 大小不能超过50MB！`); event.target.value = ''; return }
            const fileItem = { name: file.name, size: file.size, uploading: true, uploaded: false, progress: 0, fileGuid: '', uploadFileId: '', filePath: '', error: false }
            this.attachFileList.push(fileItem)
            try {
                await doFileUpload(file, {
                    fileBindId: this.fileGuid,
                    onProgress: (p) => { fileItem.progress = p },
                    onSuccess: (res) => { fileItem.uploading = false; fileItem.uploaded = true; fileItem.fileGuid = res.fileGuid; fileItem.uploadFileId = res.uploadFileId; fileItem.filePath = res.filePath; this.$message.success(`文件 ${file.name} 上传成功`) },
                    onError: (error) => { fileItem.uploading = false; fileItem.error = true; this.$message.error(`文件 ${file.name} 上传失败: ${error.message}`) }
                })
            } catch (error) { fileItem.uploading = false; fileItem.error = true; this.$message.error(`文件 ${file.name} 上传失败`) }
            event.target.value = ''
        },

        checkFileType(fileName) { return ['.pdf', '.doc', '.docx', '.xls', '.xlsx'].includes(fileName.substring(fileName.lastIndexOf('.')).toLowerCase()) },
        removeAttachFile(index) { this.attachFileList.splice(index, 1) }
    }
}
</script>

<style lang="less" scoped>
.notice-detail-page { background: #f5f5f5; min-height: 100vh; padding: 20px; }
.page-header { background: #fff; padding: 16px 20px; margin-bottom: 12px; }
.header-info { display: flex; align-items: center; }
.info-item { font-size: 14px; }
.label { color: #666; }
.value { color: #333; }
.divider { width: 1px; height: 14px; background: #ddd; margin: 0 20px; }
.form-container { background: #fff; padding: 20px; }
.section-header { padding-bottom: 16px; margin-bottom: 20px; border-bottom: 1px solid #eee; }
.title { font-size: 15px; font-weight: 500; color: #333; }
.el-checkbox { margin-right: 16px; }
.upload-area { display: flex; align-items: center; gap: 12px; }
.upload-tip { font-size: 12px; color: #999; }
.attach-file-list { margin-top: 12px; }
.attach-file-item { display: flex; align-items: center; gap: 8px; padding: 6px 0; }
.attach-file-name { flex: 1; font-size: 13px; color: #333; }
.attach-file-status { font-size: 12px; color: #67c23a; }
.attach-file-error { font-size: 12px; color: #f56c6c; }
.attach-file-remove { cursor: pointer; color: #999; &:hover { color: #f56c6c; } }
.form-footer { padding-top: 24px; margin-top: 24px; border-top: 1px solid #eee; display: flex; justify-content: center; gap: 12px; }
</style>
